<!-- your-component.vue-->
<template>
    <vue-tel-input
        ref="phoneNumber"
        v-bind:class="!isValid  ? 'is-invalid' : ''"
        v-bind:style="[ !isValid ? { borderColor: '#ea5455' } : {}]"
        v-model="phone"
        @input="input"
        @validate="validate"
        v-bind:default-country="defaultCountry"
        :inputOptions="{name: name}"
    ></vue-tel-input>
    <span class="invalid-feedback" role="alert">
        <strong>{{ message }}</strong>
    </span>
</template>
<script>
  import { ref } from 'vue';
  import { VueTelInput } from 'vue-tel-input';
  import 'vue-tel-input/dist/vue-tel-input.css';

  export default {
    props: {
        propPhone: String,
        name: String
    },
    components: {
      VueTelInput,
    },

    setup(props) {
      return {
        message: 'Not A Valid Number',
        isValid: ref(true),
        defaultCountry: ref(null),
        phone: ref(props.propPhone),
        name: props.name,
      };
    },
    created() {
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const ct = require('countries-and-timezones');
      const country = ct.getTimezone(timezone).countries[0];

      if (country === "" || !country) {
        this.defaultCountry = 'US';
        return;
      }
      this.defaultCountry = country;
    },
    emits :{
      phoneInput: null,
    },
    watch: {
        'propPhone'(value) {
            this.phone = value;
        }
    },
    methods: {
      input: function (event, object) {
        this.$emit('phoneInput', this.phone)
        this.$refs.phoneNumber.$emit('validate', this.$refs.phoneNumber.phoneObject);
      },
      validate: function (Object) {
        if(Object) {
            this.isValid = Object.valid;
        }
      }
    }
  };
</script>
